import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Footer = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <>
      <section className="section shadow-sm lazyloaded" id="developer">
        <small>
          <b>Disclaimer:</b>
          This website is managed by an authorized marketing partner and is
          intended for informational purposes only. The prices, availability,
          and offers mentioned are subject to change without prior notice.
          Images used are for representation only. The website may share
          collected data with RERA-registered brokers and real estate partners
          for further processing.
          <div className="footer-copyright">
            {/* <span>
              {" "}
              Contact Us at: Highstreet Corporate Center, Kapurbawdi Junction
              Thane (W) 400607{" "}
            </span> */}
            <span> © Copyright 2024</span>
            <span style={{ marginBottom: "50px" }}>
              {/* <a href="about.html" target="_blank">
                About Us
              </a>{" "}
              |{" "} */}
              <a href="termsandconditions.html" target="_blank">
                Terms &amp; Conditions
              </a>{" "}
              |{" "}
              <a href="privacy.html" target="_blank">
                Privacy Policy
              </a>{" "}
              |{" "}
              <a href="cookies.html" target="_blank">
                Cookies Policy
              </a>{" "}
            </span>
          </div>
        </small>
      </section>
      <ul className="mob-action nav nav-fill d-lg-none">
        <li
          className="nav-item enqModal"
          onClick={() => handleShowModal("Footer - Enquire Now")}
          style={{ cursor: "pointer", color: "#fff" }}
        >
          <i className="mi mi-download nav-icon d-inline-block animated slideInDown infinite"></i>{" "}
          Enquire
        </li>
        <a
          className="nav-item enqModal"
          // href="https://api.whatsapp.com/send?phone=9819232728&amp;text=Hi,%20I%20Would%20Like%20To%20Know%20More%20About%20Raymond MIG Bandra%20Project.%20Please%20Share%20More%20Details!"
          onClick={() => handleShowModal("Footer - WhatsApp")}
          style={{ textDecoration: "none", color: "#fff" }}
        >
          <span className="action-icon">
            <img src="images/wh.png" alt="Raymond's MIG Bandra" />
          </span>{" "}
          Whatsapp{" "}
        </a>

        <li className="nav-item">
          <a
            // href="tel:+919819232728"
            onClick={() => handleShowModal("Footer - Call Now")}
            style={{ textDecoration: "none", color: "#fff" }}
          >
            {" "}
            <span className="mi mi-call action-icon"></span> Call Now
          </a>
        </li>
      </ul>
    </>
  );
};

export default Footer;
